export const CYBER_GLOSSARY = {
  glossary: {
    name: "Cyber Glossary",
    info: "The following terms refer to items on this site; and the definitions of such terms are meant for general educational purposes only, and are not legal descriptions of the terms herein.",
    sub: [
      {
        name: "Actions",
        sortOrder: 1,
        info: "Actions refer to how the actor(s) contributed to or caused a cyber incident.",
        sub: [
          {
            name: "Environmental",
            info: "The threat from natural disasters, such as fire, earthquakes, and hurricanes that can cause physical damage to a network or computer system and result in a cyber incident.",
          },
          {
            name: "Error",
            info: "Any unintentional and non-malicious actions, mistakes, or inaction by a natural person.",
          },
          {
            name: "Misuse",
            info: "When an internal actor(s) or partner(s) uses a cyber asset for a purpose other than the original intended use, or the use goes beyond the scope of the original permission. For example, Employee A is given access to the company’s financial information to prepare for an audit.  Employee A is only supposed to review this information for potential problems or issues that may arise during the audit.  Instead, Employee A copies the information and sells it to a competitor.",
          },
          {
            name: "Hacking",
            info: "The obtaining of unauthorized or criminal access to or control of a computer system, server, or network.",
          },
          {
            name: "Malware",
            info: "Malicious software, script, or code that is specifically designed to run a program, alter or change a program, or cause a cyber incident, without the owner of the computer’s knowledge or consent.",
          },
          {
            name: "Physical",
            info: "Physical actions taken by a natural person to gain access to a computer system, device and/or network, such as a person physically accessing the hardware to install software, or stealing a laptop.  Additionally, this also refers to a cyber incident caused by the loss or theft of hard-copy documents.",
          },
          {
            name: "Social",
            info: "The use of personal information and/or a seemingly legitimate or known email address to trick a natural person into downloading malware or providing sensitive/confidential information or otherwise providing access to a network or computer system.",
          },
          {
            name: "Unknown",
            info: "There is not enough information available to determine the applicable category.",
          },
        ],
      },
      {
        name: "Actors",
        sortOrder: 2,
        info: "Actors refer to the person(s) who may contribute to or cause a cyber incident.",
        sub: [
          {
            name: "External",
            info: "A person or group of people who:  are not employed by, are not a part of, have a legitimate relationship with, or are affiliated with the affected company or organization. External Actors lack a trusting relationship with a company or organization.",
          },
          {
            name: "Internal",
            info: "A person or group of people who: are employed by, are a part of, have a legitimate relationship with, or are affiliated with a company or organization.",
          },
          {
            name: "Partner",
            info: "A person, group of people, company, or organization that is not: employed by,  a part of, or affiliated with a company or organization, but instead has a trusted business relationship with them.",
          },
          {
            name: "Unknown",
            info: "There is not enough information available to determine the applicable category.",
          },
        ],
      },
      {
        name: "Assets",
        sortOrder: 3,
        info: "An Asset is what might be compromised during a cyber incident.",
        sub: [
          {
            name: "Media",
            info: "Devices that store data offline, but that can access online hardware and computer systems; for example, a USB drive.",
          },
          {
            name: "Network",
            info: "Telecommunications devices that allows the communication and sharing of data between computer systems; for example, Wi-Fi.",
          },
          {
            name: "People",
            info: "The natural people who operate, use, or maintain computer systems.",
          },
          {
            name: "Public Terminal",
            info: "A computer system that provides a service to the public and/or is for public use; for example, an ATM machine.",
          },
          {
            name: "Server",
            info: "A computer program or device that provides functionality and managed access to a central resource of programs and devices.",
          },
          {
            name: "User Device",
            info: "A personal computing device that can store, process, and/or transmit data; for example, a smart phone.",
          },
          {
            name: "Unknown",
            info: "There is not enough information available to determine the applicable category.",
          },
        ],
      },
      {
        name: "Additional Cyber Terms",
        sortOrder: 4,
        info: "These terms are ubiquitous in the cyber industry. When referred to within the Chubb Cyber IndexSM, the following definitions apply.",
        sub: [
          {
            name: "Internet",
            info: "Refers to the global system of interconnected computers using standard communication protocols and Internet Protocol Suite (“ISP”) addresses to communicate and virtually connect.",
          },
          {
            name: "Cyber Incident",
            info: "Refers to the compromise, infection, theft, loss, or damage to data, a computer system, or software owned or operated by or on behalf of the affected company or organization.",
          },
          {
            name: "Phishing",
            info: "The use of personal information and/or a seemingly legitimate or known email address to trick an internal actor at the affected company to download malware or otherwise provide access to a network or computer system.",
          },
          {
            name: "Computer System",
            info: "Refers to the combination of hardware and software that forms a computer functioning at a basic level.",
          },
          {
            name: "Ransomware",
            info: "Malware that locks the software and data content of a computer system, making it unavailable until the payment of a ransom.",
          },
          {
            name: "Affected Company or Organization",
            info: "A company or organization that is the victim of a cyber incident.",
          },
          {
            name: "Software",
            info: "The programs, operating code, and information employed by a computer system.",
          },
          {
            name: "Hardware",
            info: "The physical and tangible component of any computer system.",
          },
        ],
      },
      {
        name: "Emerging Cyber Threat Terms",
        sortOrder: 5,
        info: "Emerging Threat refers to the new or uncommon types of cyber actions that are starting to cause Cyber Incidents, but that may not be fully defined or known about yet.",
        sub: [
          {
            name: "Spoofing",
            info: "When a malicious email or website is made to look like a legitimate email or website; additionally, when malicious Wi-Fi looks like legitimate wi-fi.",
          },
          {
            name: "USB Direct Access Fraud",
            info: "Convincing an internal actor that a USB power station or device can be used safely to either charge a mobile device or perform a function, when in fact that USB power station or device is infected with malware.",
          },
          {
            name: "Robocalls",
            info: "The automated dialing of phone numbers by a computer system directed by a malicious third party with the goal of finding phone numbers that are in use by real people in order to attempt to steal information or voice recordings of that person for the purpose of causing a cyber incident.",
          },
          {
            name: "Cyber Insider Trading",
            info: "A cyber incident that allows the malicious actor to gain access to a computer system, where they remain undetected, for the sole purposes of learning insider information in order to gain an advantage when buying and selling stocks and securities.",
          },
          {
            name: "Unauthorized Crypto Mining",
            info: "The unauthorized and concealed use of a computer system to mine for crypto currencies.",
          },
          {
            name: "Internet of Things ",
            info: "Refers to products and physical things that are able to connect to, or are run by or through, the internet.",
          },
          {
            name: "Telecommunications Fraud",
            info: "The gaining of access or unauthorized use of telecommunications (phone or internet service), which causes high bills because of overuse.",
          },
          {
            name: "Artificial Intelligence ",
            info: "The created ability of a computer to “think” or make decisions independent of human intervention and based on the data provided.",
          },
          {
            name: "Biometrics",
            info: "The use of a unique bio marker of a person (such as the person's face, fingerprint, or eye) to control or provide access to a computer system or network, or used to identify the person.",
          },
        ],
      },
    ],
  },
  links: [
    {
      name: "Explore U.S. Cyber Services",
      url: "https://www.chubb.com/us-en/business-insurance/products/cyber-insurance/us-cyber-services.html",
    },
    {
      name: "Known Exploited Vulnerabilities Catalog ",
      url: "https://www.cisa.gov/known-exploited-vulnerabilities-catalog",
    },
    {
      name: "Verizon Data Breach Investigations Report 2024",
      url: "https://www.verizon.com/business/resources/reports/dbir/",
    },
    {
      name: "Cyber Risk Management Guide for Agents & Brokers",
      url: "https://www.chubb.com/content/dam/chubb-sites/chubb-com/us-en/cyber-risk-management/agent-center/pdfs/chubb-cyber-risk-management-guide.pdf",
    },
    {
      name: "Cyber Claims Landscape: Chubb Cyber Claims Report ",
      url: "https://www.chubb.com/us-en/business-insurance/products/cyber-insurance/chubb-cyber-claims-landscape-report.html",
    },
  ],
  videoLibrary: [
    {
      name: "The Evolution of Cyber",
      src: "https://bcove.video/2YiCYY1",
    },
    {
      name: "Cyber Risk Explained",
      src: "https://bcove.video/2yHgzZM ",
    },
  ],
  cyberInsights: {
    name: "Cyber Threat Insights",
    sub: [
      {
        name: "Web Beacon",
        info: "A web beacon is a technique used on web pages and email to surreptitiously allow checking that a user has accessed some content. Web beacons are typically used by third parties to monitor the activity of users at a website for the purpose of web analytics or page tagging. They can also be used for email tracking.",
        sub: [
          "While it is possible to deploy and utilize a Web Beacon for data collection purposes lawfully, non-compliance with HIPAA has been the antecedent of several high-profile class action suits.",
          'In 2022, use of Web Beacons or "pixels" became a core regulatory focus in the healthcare sector. Hospitals and healthcare systems sometimes have Web Beacons embedded on their websites and inside password-protected patient portals – which collect PII and PHI. The unauthorized access, use, or disclosure of PII/PHI to third parties creates the potential for regulatory enforcement action.',
          "If you are unsure whether your organization utilizes a web beacon, there are a number of publicly available scanning tools that will outline what information is being collected by a given URL.",
        ],
      },
      {
        name: "SIM Swapping Scam",
        info: "A SIM swap scam is a type of account takeover fraud that generally targets a weakness in two-factor authentication and two-step verification in which the second factor or step is a text message or call placed to a mobile telephone.",
        sub: [
          "Once the scammer has successfully contacted the mobile carrier of the victim and the SIM card has been activated, the bad actor will have full control of the device. Anyone calling or texting the associated phone number will contact the scammer and not the victim.",
          "With complete access to the device data and its authenticating inboxes, the scammer’s next move is often to fraudulently access financial and healthcare related accounts. Scammers will sometimes review the social media profiles of their victims to discover information that will help them impersonate an individual.",
          "To protect yourself against SIM Swap Scams, use strong passwords and security questions that cannot be easily guessed. If your phone carrier allows you to set up a separate passcode or PIN for your communications, consider creating one. You may also implement bank and mobile carrier alerts that will call out any unusual activity.",
        ],
      },
      {
        name: "Ransomware",
        info: "Ransomware is malware that locks the software and data content of a computer system, making it unavailable until the payment of a ransom, usually involving cryptocurrency.",
        sub: [
          "From 2017 to 2018 Chubb data indicated an 84% increase in ransomware attacks.",
          "These attacks are increasingly targeted specifically against victims that have the financial ability to pay large ransoms.",
          "Many times these attacks are preceded by intrusions made by “banking trojan” malware that can “see” into the victim’s system.",
          "Many new strains of ransomware now target and encrypt an insured’s back-ups, making it difficult for them to recover from an attack.",
          "Demands in many ransomware strains like Ryuk, Bitpaymer, and Sodinokibi have now climbed into the 6 and 7-figure ranges.",
        ],
      },
      {
        name: "Internet of Things (IoT)",
        info: "Internet of things refers to products and physical things that are able to connect to, or are run by or through, the internet.",
        sub: [
          "Smart homes are going to increasingly be the target of attacks, affecting things like the home's heating and cooling system, automated door locks, lights, and alarm systems.",
          'Many "smart" devices for the home, including TV\'s and other appliances, are not equipped with adequate safeguards to protect them from outside hacking.',
          "As IoT devices continue to play an increasing role in the workplace, such as biometric (fingerprint) attendance tracking and chatbots for certain functions, these technologies may pose serious privacy risks and potential third-party liability.",
          "The ability of wearable technology, especially fitness equipment, to track an individual’s location and activity may pose a serious privacy risk that many people may be unaware of when they use these items.",
        ],
      },
      {
        name: "Human Error",
        info: "Human error refers to incidents that are triggered by some type of mistake made by a person.",
        sub: [
          "Human error has accounted for 10% of cyber incidents reported to Chubb over the last ten years.",
          "Human error is especially prevalent in the healthcare industry segment, with inadvertent disclosures accounting for an increasing number of claims.  From 2013 to 2017, human error incidents rose from 17% to 47% in healthcare.",
          "According to the 2017 Verizon Data Breach Investigations Report, 81% of hacking related breaches leveraged peoples' stolen and/or weak passwords.",
          "Document retention and destruction policies are an important part of a company's data security, as the dissemination of sensitive documents, whether intentional or inadvertent, leads to claims in many instances.",
        ],
      },
      {
        name: "DDoS",
        info: "DDoS attack refers to a Distributed Denial of Service incident in which a victim’s computer system is overwhelmed by traffic coming from multiple sources, rendering it unable to conduct its usual business.",
        sub: [
          "While no organization is exempt from a DDoS attack, usually these attacks are focused on large organizations.",
          "In many instances, DDoS attacks lead to prolonged degradations in service, which result in business interruption claims.",
          "As part of your risk-mitigation plan, you should know what parts of your system are exposed to a potential DDoS attack and how long you can afford to not have those assets in service.",
          "TDoS (Telephone Denial of Service) attacks are also a threat to businesses due to the increase in use of VoIP (Voice over Internet Protocol) calling systems.",
        ],
      },
      {
        name: "Crime-as-a-Service (CaaS)",
        info: "Crime-as-a-service refers to when professional criminals develop tools that can be sold to less-experienced bad actors to help them commit cyber crimes.",
        sub: [
          "Crime-as-a-Service is a new type of threat that is accessible with lower complexity and cost, giving anyone access to an illegal business model to use in the cloud.",
          "Many times, these services appear in the form of hacking.",
          "Demos of the process are sometimes offered, and for a modest fee, some will even do an unethical pen-testing on a target.",
          "Some services offer consultation for hacking issues, for an additional cost.",
        ],
      },
      {
        name: "Crypto Mining",
        info: "Crypto Mining, also known as “cryptojacking”, is the unauthorized and concealed use of a computer system to mine for cryptocurrencies.",
        sub: [
          "Stealing a victim’s processing power so that a bad actor can mine cryptocurrency.",
          "Mining cryptocurrency requires a great deal of computing power and electricity.",
          "Most times a victim is unaware that this is happening until they notice a slowdown in their systems.",
          "This can lead to degradation of service and a potential business interruption loss for the victim.",
        ],
      },
      {
        name: "Business Email Compromise",
        info: "Business email compromise refers to a type of attack in which some type of email fraud is used to gain unauthorized access to a victim’s system or sensitive information.",
        sub: [
          "Business Email Compromise (“BEC”) remains a major driver of claim activity.",
          "Bad actors get the victim to unknowingly supply them with user IDs and passwords to gain access to their accounts through a phishing email.",
          "Sometimes unauthorized access is gained by clicking on a malicious link or attachment.",
          "Once a bad actor gains unauthorized access to a system, they set up forwarding rules so that they can receive legitimate email traffic.",
          "Once inside the victim’s system, bad actors frequently maneuver: to gain access to sensitive data, or to initiate unauthorized payments.",
        ],
      },
    ],
  },
};
